var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.isVisible,"width":"950px","custom-class":"rekroo-dialog vacancy-form-dialog","center":true},on:{"update:visible":function($event){_vm.isVisible=$event}}},[_c('UpdateVacancy',{attrs:{"hide-hint":true,"from-dialog":true},on:{"create":_vm.onVacancyCreate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }